<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    :title="$t('approval.FORWARDED_TITLE')"
    width="520"
    @on-cancel="onCancel"
  >
    <Form
      v-if="visible"
      ref="formRef"
      :rules="formRules"
      :model="formData"
      :label-width="110"
      label-position="right"
    >
      <FormItem :label="$t('approval.currentApprover')">
        {{ currentApprover }}
      </FormItem>
      <FormItem
        :label="$t('approval.forwardEmployeeId')"
        prop="forwardEmployeeId"
      >
        <Select
          v-model="formData.forwardEmployeeId"
          filterable
          clearable
          :not-found-text="$t('i.table.noDataText')"
          @on-clear="initEmployees"
          remote
          :remote-method="remoteMethod"
          :placeholder="$t('global.search_query')"
          :loading="employeeSelectLoading"
          class="i-w-300"
        >
          <Option
            v-for="item in employees"
            :value="item.id"
            :disabled="item.id === $store.state.self.id"
            :label="item.fullName"
            :key="item.id"
          >
            {{ item.fullName }}
          </Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('global.text12')" prop="review">
        <Input
          type="textarea"
          class="i-w-300"
          :value="review"
          :placeholder="$t('global.text13')"
          :maxlength="200"
          @on-change="onChange"
          show-word-limit
        />
        <CommonPhrasesModal @onChange="onChangePhrases" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="onCancel">
        {{ $t('btn.cancel') }}
      </Button>
      <Button type="primary" :loading="submitLoading" @click="onOk">
        {{ $t('btn.done') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import CommonPhrasesModal from '@/components/CommonPhrasesModal.vue';

export default {
  components: { CommonPhrasesModal },
  data() {
    this.initFormData = {
      formId: null,
      employeeId: this.$store.state.self.id,
      formFlowId: null,
      forwardEmployeeId: null,
      review: null
    };
    return {
      visible: false,
      review: null,
      submitLoading: false,
      formData: _.cloneDeep(this.initFormData),
      formRules: {
        forwardEmployeeId: [
          {
            required: true,
            message: this.$t('global.text14')
          }
        ]
      },
      employeeSelectLoading: false,
      employees: []
    };
  },
  methods: {
    cleanReviewText(text) {
      return text
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\&nbsp;/g, ' ')
        .replace(/<.*?>/g, '');
    },
    onChangePhrases(phrases) {
      const review = `${this.review || ''}${phrases}`;
      this.formData.review = review;
      this.review = this.cleanReviewText(review);
    },
    onChange(e) {
      const rawValue = e.target.value;
      this.formData.review = rawValue
        .replace(/\r{0,}\n/g, '<br/>')
        .replace(/\s/g, '&nbsp;');
      this.review = this.cleanReviewText(rawValue);
    },
    show(value) {
      this.formData.formId = value.id;
      this.review = null;
      this.currentApprover =
        this.$store.state.self.employeeWorkInfo.displayName;
      for (let flow of value.flows) {
        if (
          flow.type === 'APPROVER' &&
          _.includes(['PENDING'], flow.status) &&
          flow.currentFlag
        ) {
          const find = _.find(flow.formFlowEmployees, (emp) => {
            return (
              emp.status === 'PENDING' &&
              emp.employee.id === this.formData.employeeId
            );
          });
          if (find) {
            this.formData.formFlowId = flow.id;
            break;
          }
        }
      }
      this.initEmployees();
      this.visible = true;
    },
    remoteMethod: _.debounce(function (query) {
      this.initEmployees(query);
    }, 300),

    async initEmployees(query) {
      try {
        this.employeeSelectLoading = true;
        const result = await this.$http(
          'get',
          'mobile/employees/select_list',
          {
            hasUser: true,
            include: 'OWNER_SHIP',
            search: query
          },
          true
        );
        this.employees = result.data.content;
      } finally {
        this.employeeSelectLoading = false;
      }
    },
    async onOk() {
      this.$refs.formRef.validate(async (v) => {
        if (v) {
          try {
            this.submitLoading = true;
            await this.$http(
              'post',
              `mobile/forms/${this.formData.formId}/forward`,
              this.formData,
              true
            );
            this.$Message.success(this.$t(`approval.forward_success`));
            this.submitLoading = false;
            this.visible = false;
            this.$emit('on-ok');
          } catch (e) {
            this.submitLoading = false;
          }
        }
      });
    },
    onCancel() {
      this.visible = false;
      this.formData = _.cloneDeep(this.initFormData);
      this.submitLoading = false;
      this.$refs.formRef.resetFields();
    }
  }
};
</script>
